import '.n{width:100%;}.ssr-plugin'
import '.cq{border-radius:0.75rem;}.ssr-plugin'
import '.h9{padding:0.5rem 1rem;}.ssr-plugin'
import '.cr{font-size:1.125rem;}.ssr-plugin'
import '.f6{line-height:1.75rem;}.ssr-plugin'
import '.ha{resize:vertical;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef, FocusEventHandler, type ReactNode } from 'react'
import { InputField } from '../InputField'
import { Text } from '../../typography/Text'

export type MultiLineTextInputProps = {
  value: string
  placeholder?: string
  label?: string
  description?: ReactNode
  labelStyle?: Style
  required?: boolean
  minHeight?: string
  style?: Style
  errorMessage?: string
  maxLength?: number
  maxLengthMessage?: string
  onBlur?: FocusEventHandler<HTMLTextAreaElement>
  setValue: (value: string) => void
}

export const MultiLineTextInput = forwardRef<
  HTMLTextAreaElement,
  MultiLineTextInputProps
>(
  (
    {
      value,
      placeholder,
      label,
      description,
      labelStyle,
      required,
      minHeight = '6.5rem',
      style,
      errorMessage,
      maxLength,
      maxLengthMessage,
      onBlur,
      setValue,
    }: MultiLineTextInputProps,
    ref,
  ) => {
    const isAtMax = maxLength !== undefined && value.length >= maxLength
    const resolvedError = errorMessage ?? (isAtMax ? maxLengthMessage : undefined)
    const hasError = !!resolvedError

    const charCounter = maxLength !== undefined ? (
      <Text.Small
        style={{
          color: isAtMax ? 'var(--brand-primary)' : 'var(--gray-300)',
          flexShrink: 0,
          userSelect: 'none',
        }}
      >
        {value.length} / {maxLength}
      </Text.Small>
    ) : undefined

    return (
      <InputField
        label={label}
        description={description}
        labelStyle={labelStyle}
        labelRight={charCounter}
        required={required}
        errorMessage={resolvedError}
      >
        <styled.textarea className="n cq h9 cr f6 ha"
          ref={ref}
          style={{
            minHeight: minHeight,
            border: `1px solid ${hasError ? 'var(--brand-primary)' : 'var(--palette-blue-300)'}`,
            background: hasError
              ? 'var(--status-error-muted)'
              : 'var(--palette-white)',
            '&:focus': {
              outline: 'none',
              border: `1px solid ${hasError ? 'var(--brand-primary)' : 'var(--brand-secondary)'}`,
            },
            '&::placeholder': {
              color: hasError ? 'var(--status-error)' : 'var(--gray-300)',
              userSelect: 'none',
            },
            ...style,
          }}
          placeholder={placeholder}
          value={value}
          onBlur={onBlur}
          onChange={(e) => setValue(e.target.value)}
        ></styled.textarea>
      </InputField>
    )
  },
)
